(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  onReady(function () {
    var body = document.body;
    var menuButton = document.querySelector('[data-fk-menu-button]');
    var nav = document.querySelector('[data-fk-nav]');

    if (menuButton && nav) {
      menuButton.addEventListener('click', function () {
        var isOpen = nav.classList.toggle('is-open');
        menuButton.setAttribute('aria-expanded', String(isOpen));
        body.classList.toggle('fk-menu-open', isOpen);
      });
      nav.addEventListener('click', function (event) {
        if (!event.target.closest('a')) return;
        nav.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
        body.classList.remove('fk-menu-open');
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth > 1160) {
          nav.classList.remove('is-open');
          menuButton.setAttribute('aria-expanded', 'false');
          body.classList.remove('fk-menu-open');
        }
      });
    }

    var ageGate = document.querySelector('[data-fk-age-gate]');
    var ageButton = document.querySelector('[data-fk-age-confirm]');
    var rewardsInvite = document.querySelector('[data-fk-rewards-invite]');
    var ageKey = 'fronto_king_age_21_confirmed_v2';
    var rewardsInviteKey = 'fronto_king_rewards_invite_seen_v1';
    var ageConfirmationWindow = 30 * 24 * 60 * 60 * 1000;
    var ageConfirmed = false;
    var rewardsInviteSeen = false;
    try {
      var ageConfirmedAt = Number(window.localStorage.getItem(ageKey) || 0);
      ageConfirmed = ageConfirmedAt > 0 && Date.now() - ageConfirmedAt < ageConfirmationWindow;
      var rewardsInviteSeenAt = Number(window.localStorage.getItem(rewardsInviteKey) || 0);
      rewardsInviteSeen = rewardsInviteSeenAt > 0 && Date.now() - rewardsInviteSeenAt < ageConfirmationWindow;
    } catch (error) {}

    function showRewardsInvite() {
      if (!rewardsInvite || window.Shopify?.designMode) return;
      rewardsInvite.hidden = false;
      body.classList.add('fk-age-locked');
      window.setTimeout(function () {
        rewardsInvite.querySelector('[data-fk-rewards-invite-action]')?.focus();
      }, 30);
    }

    function rememberRewardsInvite() {
      try { window.localStorage.setItem(rewardsInviteKey, String(Date.now())); } catch (error) {}
    }

    function closeRewardsInvite(remember, restoreFocus) {
      if (!rewardsInvite) return;
      if (remember) rememberRewardsInvite();
      rewardsInvite.hidden = true;
      body.classList.remove('fk-age-locked');
      if (restoreFocus) document.querySelector('.fk-header a, main a, main button')?.focus({ preventScroll: true });
    }

    if (!window.Shopify?.designMode) {
      if (ageGate && !ageConfirmed) {
        ageGate.hidden = false;
        body.classList.add('fk-age-locked');
        window.setTimeout(function () { ageButton?.focus(); }, 30);
      } else if (ageConfirmed && !rewardsInviteSeen) {
        window.setTimeout(showRewardsInvite, 80);
      }
    }

    ageButton?.addEventListener('click', function () {
      try { window.localStorage.setItem(ageKey, String(Date.now())); } catch (error) {}
      ageGate.hidden = true;
      showRewardsInvite();
    });

    rewardsInvite?.querySelectorAll('[data-fk-rewards-invite-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeRewardsInvite(true, false); });
    });

    rewardsInvite?.querySelectorAll('[data-fk-rewards-invite-action]').forEach(function (link) {
      link.addEventListener('click', function () {
        rememberRewardsInvite();
        body.classList.remove('fk-age-locked');
      });
    });

    document.addEventListener('keydown', function (event) {
      var activeDialog = null;
      if (rewardsInvite && !rewardsInvite.hidden) activeDialog = rewardsInvite;
      else if (ageGate && !ageGate.hidden) activeDialog = ageGate;
      if (!activeDialog) return;

      if (event.key === 'Escape' && activeDialog === rewardsInvite) {
        event.preventDefault();
        closeRewardsInvite(true, true);
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.from(activeDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (node) { return node.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.querySelectorAll('[data-fk-preview-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.FK_THEME?.previewForms) return;
        event.preventDefault();
        var status = form.querySelector('[data-fk-form-status]');
        setText(status, 'Draft form test passed. No email was sent.');
        status?.focus();
      });
    });

    var rewardsRoot = document.querySelector('[data-fk-rewards-preview]');
    if (!rewardsRoot) return;

    var tabButtons = Array.from(rewardsRoot.querySelectorAll('[data-fk-rewards-tab]'));
    var panels = Array.from(rewardsRoot.querySelectorAll('[data-fk-rewards-panel]'));

    function openRewardsPanel(name, updateHash) {
      tabButtons.forEach(function (button) {
        var active = button.dataset.fkRewardsTab === name;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.fkRewardsPanel !== name;
      });
      if (updateHash) history.replaceState(null, '', '#' + name);
      rewardsRoot.querySelector('[data-fk-rewards-panel="' + name + '"] h2')?.focus({ preventScroll: true });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () { openRewardsPanel(button.dataset.fkRewardsTab, true); });
    });
    rewardsRoot.querySelectorAll('[data-fk-rewards-jump]').forEach(function (button) {
      button.addEventListener('click', function () { openRewardsPanel(button.dataset.fkRewardsJump, true); });
    });

    var allowedPanels = tabButtons.map(function (button) { return button.dataset.fkRewardsTab; });
    function openHashedRewardsPanel() {
      var hashPanel = window.location.hash.replace('#', '');
      if (allowedPanels.indexOf(hashPanel) !== -1) openRewardsPanel(hashPanel, false);
    }
    openHashedRewardsPanel();
    window.addEventListener('hashchange', openHashedRewardsPanel);

    var sessionKey = 'fronto_king_rewards_private_preview_v1';
    var member = null;
    try { member = JSON.parse(window.sessionStorage.getItem(sessionKey) || 'null'); } catch (error) {}

    function renderMember() {
      var name = member ? [member.firstName, member.lastName].filter(Boolean).join(' ') : 'Not created in preview';
      var email = member?.email || '--';
      var city = member ? [member.city, member.state].filter(Boolean).join(', ') : '--';
      rewardsRoot.querySelectorAll('[data-fk-member-name]').forEach(function (node) { setText(node, name); });
      rewardsRoot.querySelectorAll('[data-fk-member-email]').forEach(function (node) { setText(node, email); });
      rewardsRoot.querySelectorAll('[data-fk-member-location]').forEach(function (node) { setText(node, city); });
      rewardsRoot.querySelectorAll('[data-fk-member-status]').forEach(function (node) { setText(node, member ? 'Browser-session preview' : 'Preview profile not created'); });
      rewardsRoot.querySelectorAll('[data-fk-balance]').forEach(function (node) { setText(node, member ? '0' : '--'); });
    }

    renderMember();

    var joinForm = rewardsRoot.querySelector('[data-fk-preview-join]');
    joinForm?.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(joinForm);
      if (!joinForm.checkValidity()) {
        joinForm.reportValidity();
        return;
      }
      member = {
        firstName: String(data.get('first_name') || '').trim(),
        lastName: String(data.get('last_name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        city: String(data.get('city') || '').trim(),
        state: String(data.get('state') || '').trim()
      };
      try { window.sessionStorage.setItem(sessionKey, JSON.stringify(member)); } catch (error) {}
      renderMember();
      setText(joinForm.querySelector('[data-fk-preview-message]'), 'Preview profile created for this browser tab only. No real account or email was created.');
      openRewardsPanel('account', true);
    });

    var signinForm = rewardsRoot.querySelector('[data-fk-preview-signin]');
    signinForm?.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!signinForm.checkValidity()) {
        signinForm.reportValidity();
        return;
      }
      var email = String(new FormData(signinForm).get('email') || '').trim();
      setText(signinForm.querySelector('[data-fk-preview-message]'), member && member.email.toLowerCase() === email.toLowerCase()
        ? 'Preview profile found in this browser tab. No production sign-in occurred.'
        : 'No preview profile is stored for that email in this browser tab. Create one under Join.');
    });

    var redeemForm = rewardsRoot.querySelector('[data-fk-preview-redeem]');
    redeemForm?.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!redeemForm.checkValidity()) {
        redeemForm.reportValidity();
        return;
      }
      setText(redeemForm.querySelector('[data-fk-preview-message]'), 'Code field test passed. No code was checked, consumed, or awarded points.');
    });

    rewardsRoot.querySelector('[data-fk-preview-signout]')?.addEventListener('click', function () {
      member = null;
      try { window.sessionStorage.removeItem(sessionKey); } catch (error) {}
      renderMember();
      openRewardsPanel('overview', true);
    });
  });
})();
